import { useMediaQuery } from 'react-responsive'

export function useIsDesktop(): boolean {
  return useMediaQuery({ query: '(min-width: 768px)' })
}
